import * as React from 'react';
import { connect } from 'react-redux';
import { selectUserId, State as AccessTokenState } from '~/AccessToken';
import { ExchangeRates, UnavailableDateError } from '~/Api/User/ExchangeRate';
import { fetchExchangeRates } from '~/ExchangeRate/actions';
import { selectSingleRates, selectUnavailableDateError, State as ExchangeRateState } from '~/ExchangeRate/reducer';

interface State {
	accessToken: AccessTokenState;
	exchangeRate: ExchangeRateState;
}

interface OwnProps {
	groupId: string;
	rates: ExchangeRates | null;
	date: Date | null;
}

function mapStateToProps(state: State, { groupId, rates, date }: OwnProps) {
	const userId = selectUserId(state.accessToken);

	return {
		datedRates:
			rates && date && userId ? selectSingleRates(state.exchangeRate, userId, groupId, rates.type, date) : rates,
		unavailableDateError:
			rates && date && userId
				? selectUnavailableDateError(state.exchangeRate, userId, groupId, rates.type, date)
				: null,
	};
}

const actions: { onLoad: typeof fetchExchangeRates } = {
	onLoad: fetchExchangeRates,
};

const Container: React.FunctionComponent<
	React.PropsWithChildren<{
		groupId: string;
		rates: ExchangeRates | null;
		date: Date | null;
		datedRates: ExchangeRates | null;
		unavailableDateError: UnavailableDateError | null;
		onLoad(groupId: string, type: string, date: Date | null): void;
		children(datedRates: ExchangeRates | null, unavailableDateError: UnavailableDateError | null): React.ReactNode;
	}>
> = ({ groupId, rates, date, children, datedRates, unavailableDateError, onLoad }) => {
	React.useEffect(() => {
		if (rates && date) {
			onLoad(groupId, rates.type, date);
		}
	}, [groupId, rates?.type, date]);

	return <>{children(datedRates, unavailableDateError)}</>;
};

export default connect(mapStateToProps, actions)(Container);
